<div class="user-wrapper">
	@if(!currentUser()?.loggedIn) {
		<span (click)="showLogin()" class="phb-icon icon--person-outline" [title]="'login' | translate:systemLanguage"></span>
	} @else {
		<span (click)="showLogin()" class="phb-icon icon--person" [title]="'logout' | translate:systemLanguage"></span>
	}
</div>
